module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSO BY"), _c('br')]), _c('span', {
    staticClass: "smallcaps"
  }, [_c('br')]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MAURIZIO DE GIOVANNI")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609451196/the-crocodile",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Crocodile")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609450946/i-will-have-vengeance-the-winter-of-commissario-ricciardi",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I Will Have Vengeance: "), _c('br'), _vm._v("The Winter of Commissario Ricciardi")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609451134/blood-curse-the-springtime-of-commissario-ricciardi",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blood Curse:"), _c('br'), _vm._v("The Springtime of Commissario Ricciardi")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609451431/everyone-in-their-place-the-summer-of-commissario-ricciardi",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Everyone in Their Place:"), _c('br'), _vm._v("The Summer of Commissario Ricciardi")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609451875/the-day-of-the-dead-the-autumn-of-commissario-ricciardi",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Day of the Dead:"), _c('br'), _vm._v("The Autumn of Commissario Ricciardi")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609452063/by-my-hand-a-commissario-ricciardi-mystery",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("By My Hand:")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Christmas of Commissario Ricciardi")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609452513/viper",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Viper:")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No Resurrection for Commissario Ricciardi")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609452933/the-bottom-of-your-heart-inferno-for-commissario-ricciardi",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bottom of Your Heart:")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Inferno for Commissario Ricciardi")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europaeditions.com/book/9781609453145/the-bastards-of-pizzofalcone",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bastards of Pizzofalcone")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4fc31dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/darkness-for-the-bastards-of-pizzofalcone_00000.vue
// module id = 60
// module chunks = 0